import { KeycloakService, KeycloakOptions } from 'keycloak-angular';
import { environment } from '../../../environments/environment';
import {
  getLocalStorage,
  setLocalStorage,
} from 'src/app/shared/helpers/helper';
import { HttpClientModule } from '@angular/common/http';
import { BehaviorSubject, Observable, of, using } from 'rxjs';

const loggedIn = new BehaviorSubject<boolean>(false);
const aux = null;
let keykklo = null;

function validatePath() {
  if (
    window.location.pathname === '/recuperarClave' ||
    window.location.pathname === '/loginInt' ||
    window.location.pathname === '/loginSso'
  ) {
    return false;
  }
  return true;
}

export function initializer(keycloak: KeycloakService): () => Promise<any> {
  return (): Promise<any> => {
    return new Promise(async (resolve, reject) => {
      try {
        await keycloak.init({
          config: {
            url: environment.keycloak.issuer,
            realm: environment.keycloak.realm,
            clientId: environment.keycloak.clientId,
          },
          loadUserProfileAtStartUp: false,
          initOptions: {
            onLoad: 'check-sso',
            checkLoginIframe: false,
          },
          bearerExcludedUrls: ['/recuperarClave'],
          enableBearerInterceptor: false,
        });

        keykklo = keycloak;

        await keycloak.isLoggedIn().then(valor => {
          if (valor) {
            setLocalStorage('token_sso', keykklo._instance);
            resolve(aux);
          } else {
            if (!loggedIn.getValue() && validatePath()) {
              keycloak.login({
                redirectUri: window.location.origin + '/loginSso',
              });
            } else {
              resolve(aux);
            }
          }
        });
      } catch (error) {
        reject(error);
      }
    });
  };
}
